// Medicual focus markets. Nothing here implies live partnerships or activity.

export const markets = [
  {
    id: "tanzania",
    name: "Tanzania",
    region: "East Africa",
    coord: [34.9, -6.4],
  },
  {
    id: "zambia",
    name: "Zambia",
    region: "Southern Africa",
    coord: [27.9, -13.1],
  },
  {
    id: "zimbabwe",
    name: "Zimbabwe",
    region: "Southern Africa",
    coord: [29.9, -19.0],
  },
  {
    id: "botswana",
    name: "Botswana",
    region: "Southern Africa",
    coord: [24.7, -22.3],
  },
];

export const marketById = (id) => markets.find((m) => m.id === id);
